import { CookieStore } from './cookie-store';
import { LocalStore } from './local-store';
export function buildStore(config) {
    if (config.type === 'localStorage') {
        return new LocalStore(config.key);
    }
    if (config.type === 'cookie') {
        return new CookieStore(config.key);
    }
    throw new Error('Unknown store type');
}
//# sourceMappingURL=store.js.map